<template>
  <div class="w-full p-5">
    <apollo-mutation
      :mutation="gqlMutationCreate"
      :variables="{ input: mutationVariableInput }"
      :update="updateCacheAfterMutation"
    >
      <template
        v-slot="{ mutate, loading: mutationLoading, error: mutationError }"
      >
        <section v-if="mutationLoading" class="w-full py-10 text-center">
          Loading Membuat surat keluar
        </section>

        <section v-else-if="mutationError" class="w-full py-10 text-center">
          Terjadi Kesalahan Membuat surat keluar
        </section>

        <apollo-query
          v-else
          :query="gqlQuerySelectionField"
          :variables="{ perPage: 10000 }"
        >
          <template v-slot="{ isLoading, /*query,*/ result: { error, data } }">
            <section v-if="isLoading" class="w-full py-10 text-center">
              Memuat...
            </section>

            <section v-else-if="error" class="w-full py-10 text-center">
              Terjadi Kesalahan
            </section>

            <section v-else-if="data">
              <form-wizard
                color="rgba(var(--vs-primary), 1)"
                :title="null"
                :subtitle="null"
                @on-complete="mutate()"
              >
                <tab-content
                  title="Isi Data"
                  class="mb-5"
                  icon="feather icon-edit"
                >
                  <div class="vx-row mb-5">
                    <div class="vx-col w-full">
                      <vs-input
                        class="w-full"
                        label-placeholder="Index / Judul Surat"
                        v-model="input.index"
                      />
                    </div>
                  </div>
                  <!-- <div class="vx-row mb-5">
                    <div class="vx-col w-full">
                      <vs-input
                        class="w-full"
                        label-placeholder="Tujuan"
                        v-model="input.tujuan"
                      />
                    </div>
                  </div> -->
                  <global-input-tujuan 
                    v-model="input.tujuan" 
                    :defaultData="[]"
                    :inputType="'create'"
                  >
                  </global-input-tujuan>
                  <div class="vx-row mb-5">
                    <div class="vx-col w-1/2">
                      <vs-input
                        class="w-full"
                        label-placeholder="Perihal"
                        v-model="input.perihal"
                      />
                    </div>
                    <div class="vx-col w-1/2">
                      <vs-input
                        class="w-full"
                        label-placeholder="Lampiran"
                        v-model="input.lampiran"
                      />
                    </div>
                  </div>
                  <div class="vx-row mb-5">
                    <div class="vx-col w-full">
                      <flat-pickr
                        class="w-full"
                        :config="configdateTimePicker"
                        v-model="input.tanggal"
                        placeholder="Tanggal Surat"
                      />
                    </div>
                  </div>
                  <div class="vx-row mb-5">
                    <div class="vx-col w-full">
                      <label for="" class="w-full">Isi Ringkas :</label>
                      <div class="w-full">
                        <global-quill-editor
                          v-model="input.isi_ringkas"
                        ></global-quill-editor>
                      </div>
                    </div>
                  </div>
                  <div class="vx-row mb-5">
                    <div class="vx-col w-full">
                      <label for="" class="w-full">Catatan :</label>
                      <div class="w-full">
                        <global-quill-editor
                          v-model="input.keterangan"
                        ></global-quill-editor>
                      </div>
                    </div>
                  </div>
                </tab-content>
                <tab-content
                  title="Pilih Kategori"
                  class="mb-5"
                  icon="feather icon-tag"
                >
                  <div class="vx-row mb-5">
                    <div class="vx-col w-full">
                      <label for>Kode Surat</label>
                      <vs-select
                        :options="kodeSurat"
                        class="w-full"
                        label-placeholder="Catatan"
                        v-model="input.kode_surat_id"
                        label="nama"
                        :reduce="(kode) => kode.id"
                      />
                    </div>
                  </div>
                  <div class="vx-row mb-5">
                    <div class="vx-col w-full">
                      <label for>Kategori Surat</label>
                      <vs-select
                        :options="data.kategoriSurat.data"
                        class="w-full"
                        label-placeholder="Catatan"
                        v-model="input.kategori_surat_id"
                        label="nama"
                        :reduce="(kategori) => kategori.id"
                      />
                    </div>
                  </div>
                  <div class="vx-row mb-5">
                    <div class="vx-col w-full">
                      <label for>Sifat Surat</label>
                      <vs-select
                        :options="data.sifatSurat.data"
                        class="w-full"
                        label-placeholder="Catatan"
                        v-model="input.sifat_surat_id"
                        label="nama"
                        :reduce="(sifat) => sifat.id"
                      />
                    </div>
                  </div>
                  <div class="vx-row mb-5">
                    <div class="vx-col w-full">
                      <label for>Kecepatan Surat</label>
                      <vs-select
                        :options="
                          data.kecepatanSurat.data.map(
                            ({ id, keterangan, nama }) => ({
                              id,
                              nama: `${nama} - ${keterangan}`,
                            })
                          )
                        "
                        class="w-full"
                        label-placeholder="Catatan"
                        v-model="input.kecepatan_surat_id"
                        label="nama"
                        :reduce="(kecepatan) => kecepatan.id"
                      />
                    </div>
                  </div>
                  <div class="vx-row mb-5">
                    <div class="vx-col w-full">
                      <label for>Tanda Tangan Oleh</label>
                      <vs-select
                        :options="data.pengguna.data"
                        class="w-full"
                        label-placeholder="Catatan"
                        v-model="input.tte_oleh"
                        label="nama"
                        :reduce="(sifat) => sifat.id"
                      />
                    </div>
                  </div>
                </tab-content>
              </form-wizard>
            </section>
          </template>
        </apollo-query>
      </template>
    </apollo-mutation>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { digofHttp as axios } from "@/axios";

import { GET_FIELD_SELECTION } from "@/query/surat";
import { CREATE } from "@/query/surat-keluar";
import { mapActions } from "vuex";
import { STATUS_CONCEPT } from "@/const/surat";

export default {
  components: {
    "vs-select": vSelect,
    FormWizard,
    TabContent,
    flatPickr,
  },
  data() {
    return {
      gqlQuerySelectionField: GET_FIELD_SELECTION,
      gqlMutationCreate: CREATE,
      input: {
        index: "",
        perihal: "",
        lampiran: "",
        isi_ringkas: "",
        keterangan: "",
        tujuan: [],
        tanggal: null,
        kategori_surat_id: null,
        sifat_surat_id: null,
        tte_oleh: null,
        kecepatan_surat_id: null,
      },
      configdateTimePicker: {
        dateFormat: "Y-m-d",
        time_24hr: true,
      },
      restKodeSurat: [],
    };
  },
  computed: {
    user() {
      return this.$sanctum.getUser();
    },
    mutationVariableInput() {
      const input = this.input;
      return {
        tte_oleh: input.tte_oleh,
        tujuan: null,
        surat: {
          create: {
            index: input.index,
            perihal: input.perihal,
            kode_surat_id: input.kode_surat_id,
            kategori_surat_id: input.kategori_surat_id,
            sifat_surat_id: input.sifat_surat_id,
            lampiran: input.lampiran,
            pengguna_id: this.user.id,
            tanggal: input.tanggal,
            isi_ringkas: input.isi_ringkas,
            keterangan: input.keterangan,
            kecepatan_surat_id: input.kecepatan_surat_id,
            status: STATUS_CONCEPT,
            tujuan: {
              create: input.tujuan
            }
          }
        },
        disposisi: {
          create: [
            {
              ke_pengguna: this.user.id,
              keterangan: "Membuat surat keluar",
              pengguna_id: this.user.id,
            },
          ],
        },
      };
    },
    kodeSurat() {
      return this.restKodeSurat.map(({ id, kode_surat, nama }) => ({
        id,
        nama: `${kode_surat} - ${nama}`,
      }));
    },
  },
  created() {
    this.$store.dispatch("globalApp/setHeaderTitle", "Buat Surat Keluar");
  },
  mounted() {
    this.loadKodeSurat();
  },
  methods: {
    ...mapActions({
      toggleSettingSurat: "surat/toggleSettingSurat",
    }),
    updateCacheAfterMutation(
      cache,
      {
        data: {
          suratKeluarCreate: { surat },
        },
      }
    ) {
      if (surat.uuid) this.showDetail(surat.uuid);
      this.closeForm();
    },
    showDetail(uuid) {
      // Old way open slide
      // this.$store.dispatch("surat/setDetailId", suratId);
      // this.$store.dispatch("globalApp/setShowDetail", true);

      // Route, (new way)
      this.$router.push({
        name: "surat-lihat",
        params: { uuid },
      });
    },
    closeForm() {
      this.input = this.$objectReset(this.input);
      this.$store.dispatch("globalApp/toggleCreate", false);
    },
    loadKodeSurat() {
      axios
        .get("surat-keluar/kode-surat")
        .then((r) => {
          this.restKodeSurat = r.data.data.kode_surat;
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
};
</script>

<style lang="scss">
.vue-form-wizard .wizard-tab-content {
  padding: 0 !important;
}
.vue-form-wizard .wizard-card-footer {
  padding: 0 !important;
}
</style>
